import React from 'react';

import { Header } from '../../../components/Header';
import { PageMetadata } from '../../../components/PageMetadata';
import { Footer } from '../../../components/Footer/Footer';
import { QuoteForm } from '../../../components/QuoteForm';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { GetServerPageProps } from '../../../lib/apollo';
import {
  getServerPageAgentQuote,
  getServerPageAgentQuoteSlugs,
} from './agentQuote.generated';

export default function AgentQuote({
  agent,
  data,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <PageMetadata
        pageTitle={`${agent.name} | Get Quote`}
        description={`Get a quote for Health Insurance, Medicare, Short Term, Obamacare, Dental, Vision, Individual & Family from NC insurance agent ${agent.name}.`}
        openGraphImage={agent.photo?.url ?? undefined}
      />
      <Header />

      <QuoteForm agent={agent} quoteCopy={data} />
      <Footer />
    </>
  );
}
export const getStaticProps: GetStaticProps<{
  agent: NonNullable<
    NonNullable<
      GetServerPageProps<
        typeof getServerPageAgentQuote
      >['data']['agentCollection']
    >['items'][0]
  >;
  data: NonNullable<GetServerPageProps<typeof getServerPageAgentQuote>['data']>;
}> = async ({ params }) => {
  const agentQuery = (
    await getServerPageAgentQuote({
      variables: {
        slug:
          (Array.isArray(params?.slug) ? params?.slug[0] : params?.slug) ?? '',
      },
    })
  ).props;

  const agent = agentQuery.data.agentCollection?.items[0];

  if (!agent) {
    throw new Error('Agent was not defined');
  }

  return {
    props: {
      agent,
      data: agentQuery.data,
    },
  };
};

export async function getStaticPaths() {
  const { props } = await getServerPageAgentQuoteSlugs({});
  return {
    paths: props.data.agentCollection?.items.map((agent) => ({
      params: {
        slug: agent?.slug,
      },
    })),
    fallback: false,
  };
}
